import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface User {
    uid: string;
    login: string;
    displayName: string;
    email: string;
    avatarId: string;
    domain: string;
    hasProSubscription: boolean;
    isConnectAdmin?: boolean;
}

export interface UserState {
    user: User | null;
    isAuthenticated: boolean;
}

const initialState: UserState = {
    user: null,
    isAuthenticated: false,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<User | null>) => {
            state.user = action.payload;
            state.isAuthenticated = action.payload !== null;
        },
        clearUser: state => {
            state.user = null;
            state.isAuthenticated = false;
        },
    },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
